import { HttpClient } from '@angular/common/http';
// import { Injectable } from '@angular/core';
import { Component, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'null',
  template: "<div></div>",
  standalone: true,
  providers: [HttpClient],
})

export class AppService {

  loginData: any = {};

  constructor(private http: HttpClient,private modalService: NgbModal) { }

  getApi(url: any) {
    return this.http.get(url)
  }

  postApi(url: any, data: any) {
    return this.http.post(url, data)
  }

  putApi(url: any, data: any) {
    return this.http.put(url, data)
  }

  deleteApi(url: any, data: any) {
    return this.http.delete(url, data)
  }
  open(content: any, options: any = {}) {
    return this.modalService.open(content, { ...options, centered: true });
  }

  close(modalRef: any) {
    modalRef.close();
  }
}
